import { createSlice } from '@reduxjs/toolkit';
import { TOOLTIP_INITIAL } from '~/views/private/overview/constants';

const durationTooltip = createSlice({
  name: 'durationTooltip',
  initialState: TOOLTIP_INITIAL,
  reducers: {
    setDurationTooltipInfo: (state, action) => {
      return action.payload;
    },
    updateDurationTooltipInfo: (state, action) => {
      return { ...state, ...action.payload };
    },
    hideDurationTooltip: (state, action) => {
      if (action.payload && action.payload.force) {
        return {
          show: false,
          showDashes: false,
          showLabel: false,
          showCircle: false,
        };
      }

      if (state.cursorInside) {
        return state;
      }

      if (!state.show) {
        return state;
      }

      return {
        show: false,
        showDashes: false,
        showLabel: false,
        showCircle: false,
      };
    },
  },
});

export const {
  setDurationTooltipInfo,
  updateDurationTooltipInfo,
  hideDurationTooltip,
} = durationTooltip.actions;

export default durationTooltip.reducer;
